module.exports = __webpack_public_path__ + "assets/close-circle-filled-58e842.svg";